export default __webpack_public_path__ + "assets/images/4.c35fd0.webp";